import queryString from 'query-string';
import config from '../config';
// require('es6-promise').polyfill();
// require('isomorphic-fetch');

// ---------------------------------------------------------------------------
// These functions are the basic request functions used to interact with
// api's with fetch, urls need to be passed in accordingly.
// ---------------------------------------------------------------------------
let request = {};

let tokenString = 'Token token=' + config.developer_key;

function handleErrors(res) {
  if (res.ok) {
    return res;
  }
  return res.json()
  .then(err => {
    if (err.hasOwnProperty('error')) {
      throw new Error(err.error);
    } else {
      throw new Error('An unknown error occurred');
    }
  })
}

const throwError = (err) => {
  return new Promise((resolve, reject) => {
    resolve(err)
  }).then((err) => {
    throw new Error(err)
  })
}

request.get = function (url, params, externalRequest) {
  let apiUrl = externalRequest ? url : `${config.api_url}${url}`;
  if (params) {
    apiUrl = `${apiUrl}?${queryString.stringify(params)}`;
  }
  const fetchOptions = {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  };
  return fetch(apiUrl, fetchOptions)
    .then(handleErrors)
    .then(res=>res.json());
};

request.post = function (url, body, needsAuth = true) {
  let apiUrl = `${config.api_url}${url}`;
  let token = localStorage.getItem('token')
  if (token === null && needsAuth === true) {
    return throwError('Error, token must exist')
  } else {
    let fetchOptions = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        Authorization: needsAuth ? tokenString + ':' + token : tokenString,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    };
    return fetch(apiUrl, fetchOptions)
    .then(handleErrors)
    .then(res=>res.json())
  }
};

const createFormBody = (data) => {
  let body = new FormData()
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      body.append(key, data[key]);
    }
  }
  return body;
}

request.upload = function (url, data, method='POST', needsAuth = true) {
  let apiUrl = `${config.api_url}${url}`;


  let token = localStorage.getItem('token')
  if (token === null && needsAuth === true) {
    return throwError('Error, token must exist')
  } else {
    let fetchOptions = {
      method: method,
      headers: {
        Authorization: needsAuth ? tokenString + ':' + token : tokenString,
        'Accept': 'application/json',
        //'Content-Type': 'multipart/form-data; boundary=6ff46e0b6b5148d984f148b6542e5a5d',
      },
      body: createFormBody(data)
    };
    return fetch(apiUrl, fetchOptions)
    .then(handleErrors)
    .then(res => res.json());
  }
};

request.patch = function (url, body, needsAuth = true) {
  let apiUrl = `${config.api_url}${url}`;
  let token = localStorage.getItem('token')
  if (token === null && needsAuth === true) {
    return throwError('Error, token must exist')
  } else {
    let fetchOptions = {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        Authorization: needsAuth ? tokenString + ':' + token : tokenString,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    };
    return fetch(apiUrl, fetchOptions)
    .then(handleErrors)
    .then(res=>res.json());
  }
};

request.put = function (url, body, needsAuth=true) {
  let apiUrl = `${config.api_url}${url}`;
  let token = localStorage.getItem('token')
  if (token === null && needsAuth === true) {
    return throwError('Error, token must exist')
  } else {
    let fetchOptions = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        Authorization: needsAuth ? tokenString + ':' + token : tokenString,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    };
    return fetch(apiUrl, fetchOptions)
    .then(handleErrors)
    .then(res=>res.json());
  }
};

request.protectedGet = function (url, needsAuth=true, params) {
  let apiUrl = `${config.api_url}${url}`;
  if (params) {
    apiUrl = `${apiUrl}?${queryString.stringify(params, {encode: false})}`;
  }
  let token = localStorage.getItem('token')
  if (token === null && needsAuth === true) {
    return throwError('Error, token must exist')
  } else {
    let fetchOptions = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: needsAuth ? tokenString + ':' + token : tokenString
      }
    };
    return fetch(apiUrl, fetchOptions)
    .then(handleErrors)
    .then(res=>res.json());
  }
};

request.delete = function (url, needsAuth = true) {
  let apiUrl = `${config.api_url}${url}`;
  let token = localStorage.getItem('token')
  if (token === null && needsAuth === true) {
    return throwError('Error, token must exist')
  } else {
    let fetchOptions = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        Authorization: needsAuth ? tokenString + ':' + token : tokenString,
      }
    };
    return fetch(apiUrl, fetchOptions)
    .then(handleErrors)
    .then();
  }
};

module.exports = request;



/** WEBPACK FOOTER **
 ** ./src/services/Request.js
 **/